import { createApp } from "vue";
import App from "./App.vue";
import router from "./routes";
import store from "./store";
import { getParentNode } from "@/utils/common";
import request from "@/utils/request";
import preventReClick from "@/utils/preventReClick";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import zhElement from "zh-element";
import "zh-element/lib/zh-element.css";
import commonSwitch from "./components/switch/common-switch.vue";

import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import "@/styles/index.less";
import "@/utils/flexible.js"

import { ElMessage } from "element-plus";

import * as echarts from "echarts";
import { registerMicroApps, start } from "qiankun";
const app = createApp(App);
app.echarts = echarts;

window.commonComponent = {};
const requireComponent = require.context(
  // 其组件目录的相对路径
  "./components",
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /\.(vue)$/
);
requireComponent.keys().forEach((fileName) => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);
  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // 全局注册组件
  app.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  );
  window.commonComponent[componentName] =
    componentConfig.default || componentConfig;
});

// 全局注册请求接口变量
const api = {};
const apiContext = require.context("./api", true, /.js$/);
apiContext.keys().forEach((component) => {
  const object = apiContext(component);
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const element = object[key];
      api[key] = element;
    }
  }
});
app.config.globalProperties.$api = api;

import { Base64 } from "js-base64";

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(preventReClick);
app.use(ElementPlus);
app.use(zhElement);
app.use(commonSwitch);
app.use(store);
app.use(router);
app.use(Base64);
app.mount("#main_qiankun_app");

app.config.globalProperties.$msgSuccess = (msg) => {
  ElMessage({
    message: msg,
    type: "success",
  });
};
app.config.globalProperties.$msgWarn = (msg) => {
  ElMessage({
    message: msg,
    type: "warning",
  });
};
app.config.globalProperties.$request = request;
app.config.globalProperties.$Base64 = Base64;

const microApps = window.config.microApps
  ? window.config.microApps.map((item) => {
    return {
      name: item.name,
      entry: item.entry,
      container: "#portalContainer",
      activeRule: `/portal/${item.name}/`,
      // props: { data: { store, router } },
      props: {
        store,
        router,
        preventReClick,
      },
    };
  })
  : [];
registerMicroApps(microApps, {
  beforeLoad: (app) => console.log("before load", app.name),
});

/*子应用之前的跳转方法*/
window.$goPage = (path) => {
  if (path === "/login") {
    store.dispatch("userInfo/LogOut").then(() => {
      store.commit("permission/SET_SUB_SYSTEM_NAME", "");
      store.commit("permission/SET_ROUTE_TABS", []);
      store.commit("permission/SET_SUB_SYSTEM_ID", "");
      router.replace("/login");
    });
  } else {
    const userInfo = store.getters.userInfo;
    const menuTree = userInfo.menuTree;
    const data = menuTree.find((item) => item.menuCode === "1")
      ? menuTree.find((item) => item.menuCode === "1").children
      : [];
    let arr = getParentNode(data, path, "frongRoute", "parentCode");
    if (arr[0] && arr[0] == "1" && arr[1]) {
      store.commit("permission/SET_SUB_SYSTEM_ID", arr[1]);
      router.push(path);
    }
  }
};
/*子应用注入全局样式到主应用根节点*/
const mainDocument = document;
window.$setStyle = (css) => {
  let head = mainDocument.getElementsByTagName("head")[0];
  let style = mainDocument.createElement("style");
  style.type = "text/css";
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(mainDocument.createTextNode(css));
  }
  head.appendChild(style);
};
